import React from 'react';
import clsx from 'clsx';

interface TabsProps<T extends string> {
  className?: string;
  currentTabId: T;
  setCurrentTabId: (id: T) => void;
  tabs: Array<{
    id: T;
    label: React.ReactNode;
  }>;
}

export const Tabs = <T extends string>({
  className,
  currentTabId,
  setCurrentTabId,
  tabs,
}: TabsProps<T>) => (
  <div className={clsx('flex bg-neutral-100 dark:bg-neutral-700', className)}>
    {tabs.map((tab) => (
      <button
        key={tab.id}
        className={clsx(
          'flex px-4 leading-10 text-lg text-neutral-900 dark:text-neutral-100',
          currentTabId === tab.id
            ? 'bg-neutral-300 dark:bg-neutral-900 font-bold'
            : 'bg-neutral-200 hover:bg-neutral-50 dark:bg-neutral-800',
        )}
        onClick={() => setCurrentTabId(tab.id)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);
